import { render, staticRenderFns } from "./nav-link.vue?vue&type=template&id=0bbdac46&scoped=true"
import script from "./nav-link.vue?vue&type=script&lang=js"
export * from "./nav-link.vue?vue&type=script&lang=js"
import style0 from "./nav-link.vue?vue&type=style&index=0&id=0bbdac46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbdac46",
  null
  
)

export default component.exports